import {
    GET_VERIFICATION_VIEW_DATA_BEGIN,
    GET_VERIFICATION_VIEW_DATA_SUCCESS,
    GET_VERIFICATION_VIEW_DATA_FAILURE,
    GET_VERIFICATION_VIEW_DATA_LICENCE_SUSPENDED
} from '../../../Actions/FormServiceActions/DigitalLicenceServiceActions/VerificationViewDataAction';

const initialState = {
    verificationDataServiceBegin: false,
    verificationDataServiceSucceeded: false,
    verificationDataServiceError: null,
    data: {},
    licenceSuspended: false
};

export default function formReducer (state = initialState, action) {
    switch (action.type) {
        case GET_VERIFICATION_VIEW_DATA_BEGIN:
            return {
                ...state,
                verificationDataServiceBegin: true
            };

        case GET_VERIFICATION_VIEW_DATA_SUCCESS:
            return {
                ...state,
                verificationDataServiceBegin: false,
                verificationDataServiceSucceeded: true,
                verificationDataServiceError: null,
                data: action.payload
            };

        case GET_VERIFICATION_VIEW_DATA_LICENCE_SUSPENDED:
            return {
                ...state,
                licenceSuspended: true
            };

        case GET_VERIFICATION_VIEW_DATA_FAILURE:
            return {
                ...state,
                verificationDataServiceBegin: false,
                verificationDataServiceSucceeded: false,
                verificationDataServiceError: false
            };

        default:
            return state;
    }
}
